var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTetherCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20257_8186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7607 10.7614C14.6923 15.0472 10.3514 17.6554 6.06513 16.5867C1.78062 15.5182 -0.827638 11.1772 0.2413 6.89175C1.3093 2.60552 5.65012 -0.00289863 9.9351 1.06556C14.2211 2.13402 16.8292 6.47554 15.7606 10.7615L15.7607 10.7614H15.7607Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01557 9.74147C8.95901 9.74571 8.66674 9.76315 8.01479 9.76315C7.49626 9.76315 7.12809 9.74759 6.99893 9.74147C4.99502 9.65332 3.49927 9.30448 3.49927 8.88683C3.49927 8.46917 4.99502 8.12081 6.99893 8.03125V9.39405C7.12998 9.40348 7.50521 9.42563 8.02375 9.42563C8.646 9.42563 8.95759 9.39971 9.01369 9.39452V8.03219C11.0134 8.12129 12.5058 8.47012 12.5058 8.88683C12.5058 9.30354 11.0138 9.65237 9.01369 9.74099L9.01557 9.74147ZM9.01275 7.89164V6.67215H11.8034V4.8125H4.20543V6.67215H6.99564V7.89117C4.72774 7.99535 3.02222 8.44459 3.02222 8.98292C3.02222 9.52125 4.72774 9.97002 6.99564 10.0747V13.9825H9.01228V10.0733C11.275 9.96908 12.9777 9.52031 12.9777 8.98245C12.9777 8.44459 11.2764 7.99582 9.01228 7.89117L9.01275 7.89164Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20257_8186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9984,
    height: 16,
    fill: "white",
    transform: "translate(0.00170898 0.826172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherCoin);
export default __webpack_public_path__ + "static/media/tether-coin.5569390a85161cac1170cd77fd29cbea.svg";
export { ForwardRef as ReactComponent };